import appStore from 'store';
import api from './api';
import {

  QUERY_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: {},
    coinList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
   

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetailList(state, payload) {
      state.detailList = {...payload}
    
 
    },
    setCoinList(state,payload){
      state.coinList=payload||[]
    }

  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        if(res.code==0){
          commit('setUserList', res.data);
        }
      });
    },
    addRemark({commit},data){
     return api.addRemark(data).then(res=>{
        return res
      })
    },
    getDetail({commit},data){
      api.getDetail(data).then(res=>{
        if(res.code==0){
          commit('setDetailList', res.data);
        }
      })
    },
    getCoinList({commit},data){
      api.getCoinList().then(res=>{
        if(res.code==0){
          commit('setCoinList',res.result)
        }
      })
    }
    
 
  }
};

appStore.registerModule('transcationSummary', store);
